import React from 'react';
import './location-nav.scss';
import { Link } from 'react-router-dom';
import Icon from './../Icon/Icon';
import { Popover } from 'antd';
import Badge from '../Badge/Badge';
import AnalyticsService from 'AnalyticsService';

const LocationNav = ({ launchInfo, notifications }) => {
  const showPopover = !(launchInfo.area && launchInfo.addressLine2);
  let {
    area = 'Hello',
    addressLine2 = 'Select your location to help us serve you better',
  } = launchInfo;
  if (launchInfo.addressType) {
    addressLine2 = area;
    area = launchInfo.addressType;
  }
  const locationPopoverContent = (
    <div>
      <div className="choose-location--text">
        Please select an address so that we can serve you better
      </div>
      <Link
        to="/location"
        className="button medium more button-tertiary choose-location--cta"
      >
        SELECT ADDRESS
      </Link>
    </div>
  );
  return (
    <Popover
      overlayClassName="choose-location--popover"
      content={locationPopoverContent}
      visible={showPopover}
      placement="bottomLeft"
    >
      <div className="location-nav">
        <Icon
          size={24}
          class="icon-location-bar-location-marker hide-for-desktop"
        />
        <Link
          to="/location"
          className="location-nav--location-detail"
          onClick={() => {
            // Clevertap Analytics
            const key = 'Search Location';
            AnalyticsService.clevertap.sendCleverTapEvent(key);
          }}
        >
          <div className="location-nav--location-detail--primary-text">
            <span>{area}</span>
            <Icon class="icon-common-black-arrow-right arrow-down" size={10} />
          </div>
          <div className="location-nav--location-detail--secondary-text ellipsis">
            {addressLine2}
          </div>
        </Link>
        <div className="location-nav--actions hide-for-desktop">
          <Link to="/offers" className="location-nav--actions--link">
            <Icon
              size={24}
              class="icon-location-bar-offers location-nav--actions--offers"
            />
          </Link>
          <Link to="/notifications" className="location-nav--actions--link">
            {notifications?.notificationsCount > 0 && (
              <Badge text={notifications.notificationsCount} />
            )}
            <Icon size={24} class="icon-location-bar-bell" />
          </Link>
        </div>
      </div>
    </Popover>
  );
};

export default LocationNav;
